import { RootState } from 'rootReducer';

export const errorTripSelector = (state: RootState) => state.securityModuleReducer.tripReducer.error;

export const loadingSelector = (state: RootState) => state.securityModuleReducer.tripReducer.loading;
export const faceIDSelector = (state: RootState) => ({
  loadFaceID: state.securityModuleReducer.tripReducer.loadFaceID,
  errorFaceID: state.securityModuleReducer.tripReducer.errorFaceID,
  fieldFaceID: state.securityModuleReducer.tripReducer.fieldFaceID,
});

export const fieldFaceIDSelector = (state: RootState) => state.securityModuleReducer.tripReducer.fieldFaceID;
